<table #table class="table table-striped" width="100%">
  <thead>
    <tr>
      <ng-content></ng-content>
    </tr>
  </thead>
</table>
